(function () {
  if (window.__fspOffersBound) return;
  window.__fspOffersBound = true;

  const config = window.FSP_OFFER_CONFIG || {
    threshold: 199900,
    cardamomHandle: 'premium-idukki-cardamom-50g',
    saffronHandle: 'premium-pampore-saffron-1g',
    cardamomProductId: 9373504012502,
    saffronProductId: 9373500801238,
    cardamomVariantId: 0,
    saffronVariantId: 0,
  };

  const SPECIAL_HANDLES = ['gir-kesar-mango', 'jharkhand-amrapali-mango', 'malihabad-langda-mango', 'malihabad-chausa-mango'];
  const SPECIAL_PRODUCT_IDS = [9389866156246, 9433544655062, 9433528762582];
  const SPECIAL_TITLES = ['dry fruit combo', 'super saver kashmiri nuts duo'];
  let guardRunning = false;

  function getItemHandle(item) {
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    if (item.url) {
      const match = String(item.url).match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    }
    return '';
  }

  function isOfferItem(item) {
    const handle = getItemHandle(item);
    const variantId = item.variant_id || item.id;
    const productId = item.product_id;

    if (item.properties && item.properties._fsp_offer) {
      return true;
    }

    return (
      handle === config.cardamomHandle ||
      handle === config.saffronHandle ||
      (config.cardamomProductId && productId === config.cardamomProductId) ||
      (config.saffronProductId && productId === config.saffronProductId) ||
      (config.cardamomVariantId && variantId === config.cardamomVariantId) ||
      (config.saffronVariantId && variantId === config.saffronVariantId)
    );
  }

  function isSpecialExcludedItem(item) {
    const handle = getItemHandle(item);
    const productId = item.product_id;
    const title = String(item.product_title || item.title || '')
      .toLowerCase()
      .trim();
    return (
      SPECIAL_HANDLES.includes(handle) ||
      SPECIAL_PRODUCT_IDS.includes(productId) ||
      SPECIAL_TITLES.includes(title)
    );
  }

  function getQualifyingTotal(cart) {
    let total = cart.total_price || 0;

    (cart.items || []).forEach(function (item) {
      if (isOfferItem(item) || isSpecialExcludedItem(item)) {
        total -= item.final_line_price || item.line_price || 0;
      }
    });

    return total < 0 ? 0 : total;
  }

  function getOfferItems(cart) {
    return (cart.items || []).filter(isOfferItem);
  }

  function qualifiesForOffer(cart) {
    return getQualifyingTotal(cart) >= config.threshold;
  }

  function getActiveCartItems(cartItemsElement) {
    if (cartItemsElement && typeof cartItemsElement.getSectionsToRender === 'function') {
      return cartItemsElement;
    }

    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && typeof drawerItems.getSectionsToRender === 'function') {
      return drawerItems;
    }

    const mainCartItems = document.querySelector('cart-items');
    if (mainCartItems && typeof mainCartItems.getSectionsToRender === 'function') {
      return mainCartItems;
    }

    return null;
  }

  function applyCartSections(parsedState, cartItemsElement) {
    const cartItems = getActiveCartItems(cartItemsElement);
    const cartDrawerWrapper = document.querySelector('cart-drawer');

    if (!cartItems || !parsedState || parsedState.errors) {
      return Promise.resolve(false);
    }

    cartItems.classList.toggle('is-empty', parsedState.item_count === 0);

    if (cartDrawerWrapper) {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) {
      mainCartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    if (parsedState.sections && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach(function (section) {
        const root = document.getElementById(section.id);
        if (!root || !parsedState.sections[section.section]) return;

        const target =
          (section.selector && root.querySelector(section.selector)) || root;

        target.innerHTML = cartItems.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      return Promise.resolve(true);
    }

    if (typeof cartItems.onCartUpdate === 'function') {
      return cartItems.onCartUpdate().then(function () {
        return true;
      });
    }

    return refreshCartDrawerFallback();
  }

  function refreshCartDrawerFallback() {
    return fetch((window.routes?.cart_url || '/cart') + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });
        return true;
      });
  }

  function refreshCartDrawer(cartData, cartItemsElement) {
    if (cartData && cartData.sections) {
      return applyCartSections(cartData, cartItemsElement);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && cartData && cartData.sections) {
      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      cartDrawer.renderContents(cartData);
      return Promise.resolve(true);
    }

    const cartItems = getActiveCartItems(cartItemsElement);
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      return cartItems.onCartUpdate().then(function () {
        return true;
      });
    }

    return refreshCartDrawerFallback();
  }

  function changeCartLineQuantity(line, quantity, cartItems) {
    const fetchOptions =
      typeof fetchConfig === 'function'
        ? fetchConfig()
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          };

    fetchOptions.method = 'POST';
    fetchOptions.headers = Object.assign(
      {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      fetchOptions.headers || {}
    );
    fetchOptions.body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: cartItems.getSectionsToRender().map(function (section) {
        return section.section;
      }),
      sections_url: window.location.pathname,
    });

    return fetch(window.routes?.cart_change_url || '/cart/change.js', fetchOptions)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        const parsedState = JSON.parse(text);

        if (parsedState.errors) {
          throw new Error(parsedState.errors);
        }

        return applyCartSections(parsedState, cartItems).then(function () {
          return parsedState;
        });
      });
  }

  function clampOfferQuantities(cart, cartItemsElement) {
    if (guardRunning) {
      return Promise.resolve(cart);
    }

    const cartItems = getActiveCartItems(cartItemsElement);
    if (!cartItems || typeof cartItems.getSectionsToRender !== 'function') {
      return Promise.resolve(cart);
    }

    const overQuantityLines = (cart.items || [])
      .map(function (item, index) {
        return { item: item, line: index + 1 };
      })
      .filter(function (entry) {
        return isOfferItem(entry.item) && entry.item.quantity > 1;
      });

    if (!overQuantityLines.length) {
      return Promise.resolve(cart);
    }

    guardRunning = true;
    let lastParsedState = cart;

    function clampNextLine(lineIndex) {
      if (lineIndex >= overQuantityLines.length) {
        guardRunning = false;
        return Promise.resolve(lastParsedState);
      }

      const entry = overQuantityLines[lineIndex];

      return changeCartLineQuantity(entry.line, 1, cartItems)
        .then(function (parsedState) {
          lastParsedState = parsedState;

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'fsp-offer-guard',
              cartData: parsedState,
            });
          }

          return clampNextLine(lineIndex + 1);
        });
    }

    return clampNextLine(0)
      .catch(function (error) {
        console.error('FSP offer quantity clamp error:', error);
        return lastParsedState;
      })
      .finally(function () {
        guardRunning = false;
      });
  }

  function removeInvalidOfferItems(cart, cartItemsElement) {
    if (guardRunning) {
      return Promise.resolve(cart);
    }

    const offerItems = getOfferItems(cart);
    if (!offerItems.length || qualifiesForOffer(cart)) {
      return Promise.resolve(cart);
    }

    const cartItems = getActiveCartItems(cartItemsElement);
    if (!cartItems || typeof cartItems.getSectionsToRender !== 'function') {
      return Promise.resolve(cart);
    }

    guardRunning = true;

    const lineItems = (cart.items || []).map(function (item, index) {
      return { item: item, line: index + 1 };
    });

    const offerLines = lineItems
      .filter(function (entry) {
        return isOfferItem(entry.item);
      })
      .map(function (entry) {
        return entry.line;
      });

    if (!offerLines.length) {
      guardRunning = false;
      return Promise.resolve(cart);
    }

    let lastParsedState = cart;

    function removeNextLine(lineIndex) {
      if (lineIndex >= offerLines.length) {
        guardRunning = false;
        return Promise.resolve(lastParsedState);
      }

      return changeCartLineQuantity(offerLines[lineIndex], 0, cartItems).then(function (parsedState) {
        lastParsedState = parsedState;

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'fsp-offer-guard',
            cartData: parsedState,
          });
        }

        return removeNextLine(lineIndex + 1);
      });
    }

    return removeNextLine(0)
      .catch(function (error) {
        console.error('FSP offer guard error:', error);
        return lastParsedState;
      })
      .finally(function () {
        guardRunning = false;
      });
  }

  function enforceOfferEligibility(cart, cartItemsElement) {
    if (!cart || !cart.items) {
      return Promise.resolve(cart);
    }

    return clampOfferQuantities(cart, cartItemsElement).then(function (clampedCart) {
      return removeInvalidOfferItems(clampedCart, cartItemsElement);
    });
  }

  function fetchCartAndEnforce() {
    return fetch((window.routes?.cart_url || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return enforceOfferEligibility(cart);
      })
      .catch(function () {
        return null;
      });
  }

  window.FSPOfferGuard = {
    enforce: enforceOfferEligibility,
    qualifiesForOffer: qualifiesForOffer,
    getQualifyingTotal: getQualifyingTotal,
  };

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-fsp-offer-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    handleOfferAdd(button);
  });

  function handleOfferAdd(button) {
    const variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId || button.disabled) return;

    const card = button.closest('.fsp-offer-card');
    const offersRoot = button.closest('[data-fsp-offers]');
    const useOfferVariants = offersRoot?.dataset?.useOfferVariants === 'true';
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = '...';

    fetch((window.routes?.cart_url || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!qualifiesForOffer(cart)) {
          throw new Error(
            'Add ₹' +
              Math.ceil((config.threshold - getQualifyingTotal(cart)) / 100) +
              ' more to unlock offer'
          );
        }

        const cartItems = getActiveCartItems();
        const payload = {
          id: variantId,
          quantity: 1,
        };

        if (!useOfferVariants) {
          payload.properties = { _fsp_offer: '50% off' };
        }

        if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
          payload.sections = cartItems.getSectionsToRender().map(function (section) {
            return section.section;
          });
          payload.sections_url = window.location.pathname;
        } else {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            payload.sections = cartDrawer.getSectionsToRender().map(function (section) {
              return section.id;
            });
            payload.sections_url = window.location.pathname;
          }
        }

        return fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'Could not add item');
            }
            return data;
          });
        });
      })
      .then(function (data) {
        showSuccessCard(card);

        return refreshCartDrawer(data).then(function () {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'fsp-special-offers',
              productVariantId: variantId,
              cartData: data,
            });
          }
        });
      })
      .catch(function (error) {
        console.error('FSP offer add error:', error);
        button.disabled = false;

        var message = (error && error.message) || 'Error';
        if (message.indexOf('Cannot find variant') !== -1) {
          message = 'Not published';
        }

        button.textContent = message.length > 22 ? 'Need ₹1999+' : message;
        setTimeout(function () {
          button.textContent = originalText;
        }, 2500);
      });
  }

  function showSuccessCard(card) {
    if (!card) return;
    card.classList.add('fsp-offer-card--success');
    card.innerHTML = '<div class="fsp-offer-card__success">✓ Added to cart</div>';
  }

  function bindCartUpdateListener() {
    if (window.__fspOffersSubscribed) return;
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;

    window.__fspOffersSubscribed = true;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (
        !event ||
        event.source === 'fsp-offer-guard' ||
        event.source === 'cart-items'
      ) {
        return;
      }

      if (event.cartData) {
        enforceOfferEligibility(event.cartData);
        return;
      }

      fetchCartAndEnforce();
    });
  }

  function initFspOffers() {
    bindCartUpdateListener();
    fetchCartAndEnforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFspOffers);
  } else {
    initFspOffers();
  }
})();
